import { NgModule } from "@angular/core";
import { KwikUISafeUrlPipe } from "./safe-url.pipe";

@NgModule({
  declarations: [KwikUISafeUrlPipe],
  exports: [KwikUISafeUrlPipe]
})
export class KwikUISafeUrlPipeModule {}
